<sbw-layout [backButtonVisible]="false" [continueButtonVisible]="false" [type]="mode" quoteStep="Confirmation"
    [quoteShowTotalPrice]="true">
    <div class="sbw_pagebox" *ngIf="resourcesLoaded">
        <div class="row uncollapse confirmation-container">
            <h1 id="BookingReferenceHeader">{{ concatTexts['headline'] }}</h1>
            <div [innerHTML]="'CONTENT' | resource">

            </div>
        </div>
    </div>
</sbw-layout>
